// Kuusi kenttää (kuusi_kenttaa.v1): the `kuusiKenttaa` namespace, in its own
// file so the module's strings grow here, not in fi.js / en.js / sv.js.
// The six field keys match FIELDS in apps/backend/src/modules/kuusi_kenttaa_v1/fields.js.

export const kuusiKenttaaFi = {
  title: 'Kuusi kenttää',
  hint: 'Hankkeenne ongelmanmäärittely kuutena kenttänä. Dokumenttinne ehdottavat, te vastaatte.',
  intro: 'Kuusi asiaa, jotka ongelmanmäärittelyn pitää sanoa. Jokaisen kohdalla näytetään, mitä hankkeenne omat dokumentit sanovat; kirjoittakaa oma vastauksenne tai sanokaa, ettette tiedä. Vastaukset tallentuvat heti ja näkyvät työpajassa kaikille mukana oleville kaupungeille tiiminne nimellä, ei kenenkään omalla. Älkää kirjoittako henkilöiden nimiä tai luottamuksellisia yritystietoja.',
  pickProject: 'Mikä hanke olette?',
  pickHint: 'Valinta koskee vain tätä laitetta; vastaukset tallentuvat hankkeen nimiin.',
  noProjects: 'Työpajaan ei ole vielä merkitty hankkeita.',
  changeProject: 'Vaihda hanketta',
  loading: 'Ladataan…',
  loadError: 'Kenttien lataus epäonnistui: {{message}}',
  saveError: 'Tallennus epäonnistui: {{message}}',
  saved: 'Tallennettu',
  saving: 'Lähetetään…',
  send: 'Lähetä',
  sent: 'Lähetetty',
  dontKnow: 'Emme tiedä',
  answerPlaceholder: 'Vastauksenne tähän kenttään',
  prompt: {
    present: 'Suunnitelmanne sanoo: ”{{quote}}”',
    inferable: 'Suunnitelmanne antaa ymmärtää: ”{{quote}}”',
    absent: 'Suunnitelmanne ei sano tätä.',
    none: 'Dokumenteista ei ole vielä ehdotusta.',
  },
  source: 'Lähde: {{title}}',
  verdict: { present: 'sanottu', inferable: 'pääteltävissä', absent: 'puuttuu', none: 'ei ehdotusta' },
  fields: {
    kohdejoukko: { label: 'Kohdejoukko', question: 'Kenelle ongelma on, ja kuinka monelle?' },
    sijainti: { label: 'Sijainti prosessissa', question: 'Missä päätöksessä tai kädenojennuksessa ongelma syntyy?' },
    omistaja: { label: 'Omistaja', question: 'Kuka päättää tästä tänään?' },
    rajoite: { label: 'Sitova rajoite', question: 'Mikä yksi asia sitoo eniten: raha, laki, kapasiteetti, tieto vai tahto?' },
    kokeiltu: { label: 'Mitä on jo kokeiltu', question: 'Mitä on kokeiltu ennen tätä hanketta, ja miten kävi?' },
    vastaskenaario: { label: 'Vastaskenaario', question: 'Mitä tapahtuu, jos mitään ei tehdä, ja mihin mennessä?' },
  },
  wall: {
    title: 'Kuusi kenttää',
    subtitle: '{{projects}} hanketta · {{filled}} / {{total}} kenttää täytetty',
    legend: { filled: 'tiimi vastannut', suggested: 'dokumentit ehdottavat', open: 'avoin' },
    project: 'Hanke',
    empty: 'Työpajaan ei ole merkitty hankkeita.',
    dontKnow: 'emme tiedä',
    count: '{{answers}} vastausta · {{replied}} jatkokysymykseen vastattu',
    open: 'avaa',
    error: 'Ruudukon lataus epäonnistui: {{message}}',
  },
  followup: {
    title: 'Jatkokysymys',
    pending: 'Tekoäly lukee vastauksenne ja miettii yhden jatkokysymyksen. Tässä menee noin minuutti; voitte jatkaa seuraavaan kenttään.',
    failed: 'Jatkokysymystä ei saatu tällä kertaa. Vastaus on tallessa.',
    answerPlaceholder: 'Vastatkaa 1–3 lauseella omasta kokemuksestanne',
    answer: 'Vastaa',
    skip: 'Ohita',
    skipped: 'ohitettu',
    target: 'kohti tavoitetta {{target}}',
    stage: { tuotos: 'tuotos', edellytys: 'edellytys', tulos: 'tulos', vaikuttavuus: 'vaikuttavuus' },
  },
  room: {
    subtitle: 'Täyttäkää hankkeenne kuusi kenttää. Vastaukset tallentuvat heti ja näkyvät seinällä.',
    noInstance: 'Työpajaa ei ole valittu: avaa sivu työpajan linkistä (?instance=…).',
    disabled: 'Kuusi kenttää ei kuulu tähän työpajaan.',
  },
};

export const kuusiKenttaaEn = {
  title: 'Six fields',
  hint: 'Your project\'s problem statement as six fields. Your documents suggest, you answer.',
  intro: 'Six things a problem statement must say. For each, what your project\'s own documents say is shown; write your own answer or say you do not know. Answers save at once and are visible in the workshop to every participating town, under your team\'s name, never anyone\'s own. Do not write people\'s names or confidential company information.',
  pickProject: 'Which project are you?',
  pickHint: 'The choice is for this device only; answers are saved under the project.',
  noProjects: 'No projects have been set for this workshop yet.',
  changeProject: 'Change project',
  loading: 'Loading…',
  loadError: 'Loading the fields failed: {{message}}',
  saveError: 'Saving failed: {{message}}',
  saved: 'Saved',
  saving: 'Sending…',
  send: 'Send',
  sent: 'Sent',
  dontKnow: 'We don\'t know',
  answerPlaceholder: 'Your answer for this field',
  prompt: {
    present: 'Your plan says: “{{quote}}”',
    inferable: 'Your plan implies: “{{quote}}”',
    absent: 'Your plan does not say this.',
    none: 'No suggestion from the documents yet.',
  },
  source: 'Source: {{title}}',
  verdict: { present: 'stated', inferable: 'inferable', absent: 'missing', none: 'no suggestion' },
  fields: {
    kohdejoukko: { label: 'Target group', question: 'Who is the problem for, and how many?' },
    sijainti: { label: 'Place in the process', question: 'In which decision or hand-over does the problem arise?' },
    omistaja: { label: 'Owner', question: 'Who decides this today?' },
    rajoite: { label: 'Binding constraint', question: 'Which one thing binds most: money, law, capacity, knowledge or will?' },
    kokeiltu: { label: 'What has been tried', question: 'What was tried before this project, and how did it go?' },
    vastaskenaario: { label: 'Counter-scenario', question: 'What happens if nothing is done, and by when?' },
  },
  wall: {
    title: 'Six fields',
    subtitle: '{{projects}} projects · {{filled}} / {{total}} fields filled',
    legend: { filled: 'team answered', suggested: 'documents suggest', open: 'open' },
    project: 'Project',
    empty: 'No projects have been set for this workshop.',
    dontKnow: 'we don\'t know',
    count: '{{answers}} answers · {{replied}} follow-ups replied',
    open: 'open',
    error: 'Loading the grid failed: {{message}}',
  },
  followup: {
    title: 'Follow-up question',
    pending: 'The AI is reading your answer and thinking of one follow-up question. This takes about a minute; you can go on to the next field.',
    failed: 'No follow-up question this time. Your answer is saved.',
    answerPlaceholder: 'Answer in 1–3 sentences from your own experience',
    answer: 'Answer',
    skip: 'Skip',
    skipped: 'skipped',
    target: 'toward goal {{target}}',
    stage: { tuotos: 'output', edellytys: 'condition', tulos: 'outcome', vaikuttavuus: 'impact' },
  },
  room: {
    subtitle: 'Fill in your project\'s six fields. Answers save at once and appear on the wall.',
    noInstance: 'No workshop selected: open the page from the workshop link (?instance=…).',
    disabled: 'Six fields is not part of this workshop.',
  },
};

export const kuusiKenttaaSv = {
  title: 'Sex fält',
  hint: 'Ert projekts problemformulering som sex fält. Era dokument föreslår, ni svarar.',
  intro: 'Sex saker som en problemformulering måste säga. För var och en visas vad ert projekts egna dokument säger; skriv ert eget svar eller säg att ni inte vet. Svaren sparas genast och syns i workshoppen för alla deltagande städer, under teamets namn, aldrig under någons eget. Skriv inte personers namn eller konfidentiell företagsinformation.',
  pickProject: 'Vilket projekt är ni?',
  pickHint: 'Valet gäller bara den här enheten; svaren sparas under projektet.',
  noProjects: 'Inga projekt har angetts för den här workshopen ännu.',
  changeProject: 'Byt projekt',
  loading: 'Laddar…',
  loadError: 'Fälten kunde inte laddas: {{message}}',
  saveError: 'Sparandet misslyckades: {{message}}',
  saved: 'Sparat',
  saving: 'Skickar…',
  send: 'Skicka',
  sent: 'Skickat',
  dontKnow: 'Vi vet inte',
  answerPlaceholder: 'Ert svar för det här fältet',
  prompt: {
    present: 'Er plan säger: ”{{quote}}”',
    inferable: 'Er plan antyder: ”{{quote}}”',
    absent: 'Er plan säger inte detta.',
    none: 'Inget förslag från dokumenten ännu.',
  },
  source: 'Källa: {{title}}',
  verdict: { present: 'sagt', inferable: 'kan härledas', absent: 'saknas', none: 'inget förslag' },
  fields: {
    kohdejoukko: { label: 'Målgrupp', question: 'Vem är problemet för, och hur många?' },
    sijainti: { label: 'Plats i processen', question: 'I vilket beslut eller vilken överlämning uppstår problemet?' },
    omistaja: { label: 'Ägare', question: 'Vem beslutar om detta i dag?' },
    rajoite: { label: 'Bindande begränsning', question: 'Vilken enskild sak binder mest: pengar, lag, kapacitet, kunskap eller vilja?' },
    kokeiltu: { label: 'Vad som redan prövats', question: 'Vad prövades före det här projektet, och hur gick det?' },
    vastaskenaario: { label: 'Motscenario', question: 'Vad händer om inget görs, och när?' },
  },
  wall: {
    title: 'Sex fält',
    subtitle: '{{projects}} projekt · {{filled}} / {{total}} fält ifyllda',
    legend: { filled: 'teamet har svarat', suggested: 'dokumenten föreslår', open: 'öppet' },
    project: 'Projekt',
    empty: 'Inga projekt har angetts för den här workshopen.',
    dontKnow: 'vi vet inte',
    count: '{{answers}} svar · {{replied}} följdfrågor besvarade',
    open: 'öppna',
    error: 'Rutnätet kunde inte laddas: {{message}}',
  },
  followup: {
    title: 'Följdfråga',
    pending: 'AI:n läser ert svar och formulerar en följdfråga. Det tar ungefär en minut; ni kan gå vidare till nästa fält.',
    failed: 'Ingen följdfråga den här gången. Svaret är sparat.',
    answerPlaceholder: 'Svara med 1–3 meningar utifrån er egen erfarenhet',
    answer: 'Svara',
    skip: 'Hoppa över',
    skipped: 'överhoppad',
    target: 'mot målet {{target}}',
    stage: { tuotos: 'prestation', edellytys: 'förutsättning', tulos: 'resultat', vaikuttavuus: 'effekt' },
  },
  room: {
    subtitle: 'Fyll i ert projekts sex fält. Svaren sparas genast och visas på väggen.',
    noInstance: 'Ingen workshop vald: öppna sidan från workshopens länk (?instance=…).',
    disabled: 'Sex fält ingår inte i den här workshopen.',
  },
};
